import React from 'react';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <h1 className="legal-title">Terms and Conditions</h1>
          <p className="legal-subtitle">Welcome to Devroom!</p>
        </div>

        <div className="legal-content">
          <div className="legal-section">
            <p>These terms and conditions outline the rules and regulations for the use of Devroom's Website, located at <a href="https://www.devroom.in/" className="highlight-link">https://www.devroom.in/</a>.</p>
            <p>By accessing this website we assume you accept these terms and conditions. Do not continue to use Devroom if you do not agree to take all of the terms and conditions stated on this page.</p>
            
            <h3>Terminology</h3>
            <p>The following terminology applies to these Terms and Conditions, Privacy Statement, Disclaimer Notice, and all Agreements:</p>
            <ul>
              <li><strong>"Client", "You" and "Your"</strong> refers to you, the person accessing this website and complying with the Company's terms and conditions.</li>
              <li><strong>"The Company", "Ourselves", "We", "Our" and "Us"</strong> refers to our company, Devroom.</li>
              <li><strong>"Party", "Parties", or "Us"</strong> refers to both the Client and ourselves.</li>
            </ul>
            
            <p>All terms refer to the offer, acceptance, and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client's needs in respect of the provision of the Company's stated services. This is done in compliance with applicable laws and regulations of the jurisdiction in which the Client resides or accesses the services, as well as any international laws that may apply.</p>
            
            <p>Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore refer to the same.</p>
          </div>

          <div className="legal-section">
            <h2>License</h2>
            <p>Unless otherwise stated, Devroom and/or its licensors own the intellectual property rights for all material on Devroom. All intellectual property rights are reserved. You may access this from Devroom for your own personal use subjected to restrictions set in these terms and conditions.</p>
            
            <h3>You must not:</h3>
            <ul>
              <li>Republish material from Devroom</li>
              <li>Sell, rent or sub-license material from Devroom</li>
              <li>Reproduce, duplicate or copy material from Devroom</li>
              <li>Redistribute content from Devroom</li>
            </ul>
            
            <p><strong>This Agreement shall begin on the date hereof.</strong></p>
          </div>

          <div className="legal-section">
            <h2>Hyperlinking to our Content</h2>
            
            <h3>The following organizations may link to our Website without prior written approval:</h3>
            <ul>
              <li>Government agencies</li>
              <li>Search engines</li>
              <li>News organizations</li>
              <li>Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses</li>
              <li>System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site</li>
            </ul>

            <p>These organizations may link to our home page, to publications or to other Website information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party's site.</p>

            <h3>We may consider and approve other link requests from the following types of organizations:</h3>
            <ul>
              <li>Commonly-known consumer and/or business information sources</li>
              <li>Dot.com community sites</li>
              <li>Associations or other groups representing charities</li>
              <li>Online directory distributors</li>
              <li>Internet portals</li>
              <li>Accounting, law and consulting firms</li>
              <li>Educational institutions and trade associations</li>
            </ul>

            <p>We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavorably to ourselves or to our accredited businesses; (b) the organization does not have any negative records with us; (c) the benefit to us from the visibility of the hyperlink compensates the absence of Devroom; and (d) the link is in the context of general resource information.</p>

            <p>These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party's site.</p>

            <p>If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by sending an e-mail to Devroom. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.</p>

            <h3>Approved organizations may hyperlink to our Website as follows:</h3>
            <ul>
              <li>By use of our corporate name</li>
              <li>By use of the uniform resource locator being linked to</li>
              <li>By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking party's site</li>
            </ul>

            <p>No use of Devroom's logo or other artwork will be allowed for linking absent a trademark license agreement.</p>
          </div>

          <div className="legal-section">
            <h2>Content Liability</h2>
            <p>We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.</p>
          </div>

          <div className="legal-section">
            <h2>Your Privacy</h2>
            <p>Please read our Privacy Policy for detailed information about how we collect, use, and protect your personal information.</p>
          </div>

          <div className="legal-section">
            <h2>Reservation of Rights</h2>
            <p>We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amend these terms and conditions and it's linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.</p>
          </div>

          <div className="legal-section">
            <h2>Removal of links from our website</h2>
            <p>If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly.</p>
            <p>We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date.</p>
          </div>

          <div className="legal-section">
            <h2>Disclaimer</h2>
            <p>To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. Nothing in this disclaimer will:</p>
            
            <ul>
              <li>Limit or exclude our or your liability for death or personal injury</li>
              <li>Limit or exclude our or your liability for fraud or fraudulent misrepresentation</li>
              <li>Limit any of our or your liabilities in any way that is not permitted under applicable law</li>
              <li>Exclude any of our or your liabilities that may not be excluded under applicable law</li>
            </ul>

            <p>The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty.</p>
            
            <p><strong>As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.</strong></p>
          </div>

          <div className="contact-info">
            <h3>Questions About These Terms?</h3>
            <p>If you have any questions about these Terms and Conditions, please don't hesitate to contact us.</p>
            <p><strong>Email:</strong> <a href="mailto:info@devroom.in" className="highlight-link">info@devroom.in</a></p>
            <p><strong>Response Time:</strong> Within 24 hours</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
